<template>
    <header class="header-combined" :class="{ 'header-combined--two-row': ['type_5', 'type_6'].includes(shopTheme) }">
        <!-- type_1: shop_id 없는 기본 헤더 (404 등) -->
        <template v-if="shopTheme === 'type_1'">
            <HeaderMenuType1 :loading="loading" :data="data" />
        </template>

        <!-- type_2 (kumon): 전용 헤더 — 사용자 정보 표시 -->
        <template v-else-if="shopTheme === 'type_2'">
            <HeaderMenuType2 :loading="loading" :data="data" />
        </template>

        <!-- type_3: 신규 통합 헤더 -->
        <template v-else-if="shopTheme === 'type_3'">
            <HeaderMenuType3 :loading="loading" :data="data" />
        </template>

        <!-- type_4 (ohprint): DB 메뉴 기반 헤더 -->
        <template v-else-if="shopTheme === 'type_4'">
            <LogoBar4 :loading="loading" :data="data" class="d-md-none header-logo-area" />
            <HeaderMenuLogin v-if="$route.name === 'Login'" :loading="loading" :data="data" class="d-none d-md-flex header-nav-area" />
            <HeaderMenu v-else :loading="loading" :data="data" class="d-none d-md-flex header-nav-area" />
        </template>
        <!-- type_5: type_4 구성 두 줄 (LogoBar6 모바일 + HeaderMenuType6 데스크톱) -->
        <template v-else-if="shopTheme === 'type_5'">
            <LogoBar6 :loading="loading" :data="data" class="d-md-none header-logo-area" />
            <HeaderMenuType6 :loading="loading" :data="data" class="d-none d-md-block header-nav-area" />
        </template>
        <!-- type_6  -->
        <template v-else-if="shopTheme === 'type_6'">
            <LogoBar6 :loading="loading" :data="data" class="d-md-none header-logo-area" />
            <HeaderMenuType6 :loading="loading" :data="data" class="d-none d-md-block header-nav-area" />
        </template>
        <!-- type_7  -->
        <template v-else-if="shopTheme === 'type_7'">
            <HeaderMenuType7 :loading="loading" :data="data" />
        </template>

        <!-- 기본 헤더 (테마 미지정) -->
        <template v-else>
            <LogoBar4 :loading="loading" :data="data" class="d-md-none header-logo-area" />
            <HeaderMenuLogin v-if="$route.name === 'Login'" :loading="loading" :data="data" class="d-none d-md-flex header-nav-area" />
            <HeaderMenu v-else :loading="loading" :data="data" class="d-none d-md-flex header-nav-area" />
        </template>
    </header>
</template>

<script>
    import { mapGetters } from 'vuex';

    import LogoBarBase from './LogoBarBase.vue';
    import HeaderNavs from './HeaderNavs.vue';
    import HeaderMenuType1 from './type_1/HeaderMenu.vue';
    import HeaderMenuType2 from './type_2/HeaderMenu.vue';
    import HeaderMenuType3 from './type_3/HeaderMenu.vue';
    import HeaderMenuType5 from './type_5/HeaderMenu.vue';
    import HeaderMenuType6 from './type_6/HeaderMenu.vue';
    import LogoBar6 from './type_6/LogoBar.vue';
    import HeaderMenuType7 from './type_7/HeaderMenu.vue';

    import LogoBar4 from './type_4/LogoBar.vue';
    import HeaderMenu from './type_4/HeaderMenu.vue';
    import HeaderMenuLogin from './type_4/HeaderMenu_login.vue';

    export default {
        components: {
            LogoBarBase,
            HeaderNavs,
            HeaderMenuType1,
            HeaderMenuType2,
            HeaderMenuType3,
            HeaderMenuType5,
            HeaderMenuType6,
            LogoBar6,
            HeaderMenuType7,
            LogoBar4,
            HeaderMenu,
            HeaderMenuLogin,
        },
        data: () => ({
            loading: true,
            data: {},
        }),
        computed: {
            ...mapGetters('auth', ['shopTheme']),
        },
        watch: {
            '$route.params.slug'(slug) {
                this.getDetails(slug);
            },
        },
        methods: {
            async getDetails(slug) {
                const url = slug ? `setting/header?slug=${slug}` : 'setting/header';
                const res = await this.call_api('get', url);
                if (res.status === 200) {
                    this.data = res.data;
                    this.loading = false;
                }
            },
        },
        created() {
            this.getDetails(this.$route.params.slug);
        },
    };
</script>

<!-- navs.scss: HeaderNavs / ServiceNavs 전역 스타일 — scoped 불가 -->
<style lang="scss">
    @import '../../../sass/navs.scss';
</style>
<style lang="scss" scoped>
    .header-combined {
        display: flex;
        align-items: stretch;
        height: 75px;
        border-bottom: 1px solid #dddddd;

        &--two-row {
            height: auto;
            padding-top: 10px;

            @media (max-width: 959px) {
                height: 75px;
                padding-top: 0;
            }
        }
    }
    .header-logo-area {
        flex: 1;
        min-width: 0;
    }
    .header-nav-area {
        flex: 1;
        min-width: 0;
    }
</style>
